

import moment from "moment";
import { handleValidateCodevalue } from "./constant";

export const stripHtmlAndWhitespace = (html) => {
    if (!html) return "";
    
    let text = html.replace(/<[^>]*>?/gm, ' ');
    
    try {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        text = doc.documentElement.textContent || text;
    } catch (e) {
    }
    
    text = text.replace(/[\n\r\t]+/g, ' ');
    text = text.replace(/\s\s+/g, ' ');
    
    return text.trim();
};


export const removeExcessiveTags = (html) => {
    if (!html) return "";

    let content = html;
    
    content = content.replace(/(<p><br><\/p>\s*){2,}/gi, '<p><br></p>');
    
    content = content.replace(/^(<p><br><\/p>\s*)+/i, '');
    
    content = content.replace(/(<p><br><\/p>\s*)+$/i, '');
    
    content = content.replace(/(<br\s*\/?>\s*){2,}/gi, '<br>');

    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, "text/html");
        const body = doc.body;

        body.querySelectorAll("p, h1, h2, h3, h4, h5, h6").forEach((el) => {
            const existingStyles = el.getAttribute("style") || "";
            
            if (!/margin\s*:/i.test(existingStyles)) {
                // ...we safely append our margin and padding resets, retaining their existing styles safely.
                el.setAttribute("style", `margin: 0; padding: 0; ${existingStyles}`.trim());
            }
        });

        // Also neutralize vertical margins on lists, but preserve padding so bullet points stay visible!
        body.querySelectorAll("ul, ol").forEach((el) => {
            const existingStyles = el.getAttribute("style") || "";
            if (!/margin\s*:/i.test(existingStyles)) {
                el.setAttribute("style", `margin-top: 0; margin-bottom: 0; ${existingStyles}`.trim());
            }
        });

        return body.innerHTML.trim();
    } catch (error) {
        console.error("HTML parsing error in removeExcessiveTags, falling back to basic cleanup:", error);
        return content.trim();
    }
};


export const valueFormatter = (card, item, internationalise) => {
  let value = card?.[item.field];
  
  if (item.combineFields) {
    value = item.combineFields
      .map((field) => card?.[field] || "")
      .join(" ")
      .trim();
  }
  if (item.type === "currency" && value) {
    value = new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(value);
  }
  if (item.stripHtml && value) {
    value = stripHtmlAndWhitespace(value);
  }

  if (item.useLabel && value) {
    value = handleValidateCodevalue(internationalise, value);
  }
  if (item.type === "date" && value) {
    value = moment(value).format(item.format || "DD/MM/YYYY");
  }

  if(item?.firstName && item?.lastName){
    value = `${item?.firstName} ${item?.lastName}`
  }
  if (item.truncate && value?.length > 50) {
    return {
      displayValue: value.slice(0, 50) + "...",
      fullValue: value
    };
  }
  return {
    displayValue: value,
    fullValue: value
  };
};